<template>
    <div ref="container">
        <div class="clear" @click="del" v-if="productList.length>0">
            <img src="../../assets/newImg/clear.png" alt="" />
            <div>一键已读</div>
        </div>
        <!-- <div style="height:15px"></div> -->
        <div class="news-list" ref="container">
            <div
                class="news-li"
                v-for="(item, index) in productList"
                :key="index"
                @click="read(item.id, index)"
            >
                <div class="bage" v-if="item.status == 0"></div>
                <div class="news-li-top">
                    <div class="left">
                        <img src="../../assets/newImg/news.png" alt="" />
                        <div>{{ item.title }}</div>
                    </div>
                    <div class="right">{{ item.date }}</div>
                </div>
                <div class="news-li-bottom">{{ item.message }}</div>
            </div>
        </div>
        <div class="no-show" v-if="productList.length == 0 && loadend">
            <img src="../../assets/newImg/no_show.png" alt="" />
        </div>
        <div class="loading-more" v-if="loadend">暂无更多了</div>
    </div>
</template>
<style scoped>
.clear {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 50px;
}
.clear img {
    width: 15px;
    height: 15px;
}
.clear div {
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
    padding-left: 10px;
    padding-right: 11px;
}
.news-list {
    margin: 0 10px;
}
.news-list .news-li {
    width: 100%;
    height: 93px;
    background: #ffffff;
    border-radius: 10px;
    margin-bottom: 10px;
    position: relative;
}
.news-list .bage {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #d01112;
    position: absolute;
    right: 0;
    top: 0;
}
.news-list .news-li .news-li-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 11px 0 16px;
    height: 55px;
}
.news-list .news-li .news-li-top .left {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.news-list .news-li .news-li-top .left img {
    width: 19px;
    height: 15px;
}
.news-list .news-li .news-li-top .left div {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #333333;
    padding-left: 10px;
}
.news-list .news-li .news-li-top .right {
    color: #999999;
    font-size: 12px;
}
.news-list .news-li .news-li-bottom {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    padding: 0 44px 18px 44px;
}
</style>
<script>
import { news, readNews, readAll } from "@api/user";
export default {
    name: "news",
    data() {
        return {
            loading: false,
            loadend: false,
            where: {
                page: 1,
                limit: 10,
            },
            productList: [],
        };
    },
    methods: {
        list() {
            let that = this;
            if (that.loading) return;
            if (that.loadend) return;
            that.loading = true;
            let q = that.where;
            news(q).then((res) => {
                that.loading = false;
                that.productList.push.apply(that.productList, res.data.data);
                that.loadend = res.data.data.length < that.where.limit;
                that.where.page = that.where.page + 1;
            });
        },
        /**已读 */
        read(id, index) {
            let productList = this.productList;
            let params = { id: id };
            readNews(params).then((res) => {
                // eslint-disable-line no-unused-vars
                productList[index].status = 1;
            });
        },
        /**全部消息已读 */
        del() {
            let _this = this,
                productList = this.productList;
            readAll().then((res) => {
                // this.$dialog.toast({ mes: res.msg });
                for (var i in productList) {
                    productList[i].status = 1;
                }
                _this.productList = productList;
            });
        },
    },
    mounted() {
        this.list();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.list();
        });
    },
};
</script>
